export const getHeaders = () => {
  return {
    'Content-Type': 'application/json',
    'X-CSRF-Token': document.querySelector('[name=csrf-token]')?.content || 'test',
  };
};
